import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import BalancosOrcamentarios from '../../components/balanco/listar/orcamentario';


function BalancosOrcamentariosScreen () {
    return (
        <Fragment>
            <Head titulo="Balanços Orçamentários do Município de Macuco"/>
            <Header />
            <Container>
                <BalancosOrcamentarios />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default BalancosOrcamentariosScreen;